import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    assetTypeId: undefined
  },
  mutations: {
    setTypeId(state, id) {
      state.assetTypeId = id
    }
  },
  actions: {
  },
  modules: {
  }
})
